import { motion } from "framer-motion";
import * as geohash from "geofire-common";
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { useEffect, useState } from "react";
import { FaMapPin } from "react-icons/fa";
import { FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { orderAtom } from "../atoms/checkoutManager";
import { submitOrder } from "../functions/submitOrder";
 
mapboxgl.accessToken = 'pk.eyJ1Ijoia3VsdHVyZXJzYSIsImEiOiJjbDR5MmZkdmUwOWllM2lvNnQ4c2g3OTlxIn0._5lJS7W5xk6h4gLDp4bW8w';

export default function ConfirmDelivery() {

    const navigate = useNavigate()

    const [fee, setFee] = useState(0)
    
    const [map, setMap] = useState(null)
    const [mapWrapper, setMapWrapper] = useState(null)
    const [changing, setChanging] = useState(false)
    const [order, setOrder] = useRecoilState(orderAtom)
    const store = [30.4104368,-23.0155529]
    const auth = {
        currentUser: JSON.parse(localStorage.getItem("user"))
    }

    useEffect(() => {

        if(!mapWrapper) return () => null;

        window.navigator.geolocation.getCurrentPosition(pos => {

            const mp = new mapboxgl.Map({
                container: mapWrapper,
                style: 'mapbox://styles/mapbox/streets-v12',
                center: [pos.coords.longitude, pos.coords.latitude],
                zoom: 14
            });

            const feeVal = geohash.distanceBetween([pos.coords.longitude, pos.coords.latitude], store) * (2)
            const minimum = 10
            let charge = true ? (feeVal < minimum ? (0).toFixed(2) : feeVal.toFixed(2)) : 0
        
            //display fee
            setFee(Number(charge))

            setMap(mp)

        }, err => {
            console.log(err)
        }, { enableHighAccuracy: true })

    }, [mapWrapper])

    useEffect(() => {
        if (!map) return; // wait for map to initialize

        map.on('moveend', () => {
 
            const lng = map.getCenter().lng
            const lat = map.getCenter().lat

            //get distance
            const feeVal = geohash.distanceBetween([lng, lat], store) * (2)
            const minimum = 10
            let charge = true ? (feeVal < minimum ? (0).toFixed(2) : feeVal.toFixed(2)) : 0
        
            //display fee
            setFee(Number(charge))
            setOrder(c => ({
                ...c, 
                address: {
                    location: {
                        latitude: lat,
                        longitude: lng
                    }
                }
            }))
        });

    }, [map]);

    return (
        <div >

            <div ref={setMapWrapper} onTouchStart={() => setChanging(true)} onTouchEnd={() => setChanging(false)} className="delivery-map" />

            <div id="markerWrapper"
            >
                <motion.div animate={{ y: changing ? -10 : -5 }}>
                    <FaMapPin color="#000" size={40} />
                </motion.div>
            </div>

            <div
                style={{ position: "fixed", top: 10, width: "100vw", margin: "0 auto", display: 'flex', justifyContent: "center" }}
            >
                <button  id="sign-in-button" style={{
                    width: "150px !important"
                }}>+ R{fee.toFixed(2)} Delivery</button>
            </div>

            <div className="row" style={{ width: "100%", position: "fixed", top: 0, margin: 15 }}>
                <FiArrowLeft 
                    color="#000"
                    className="back-button"
                    size={30}
                    onClick={() => window.history.back()}
                />
            </div>

            <motion.div initial={{ y: 15, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.2 }} id="checkoutButton" style={{ display: 'block' }} >
                <p style={{ textAlign: "center" }}>Move map to set location</p>
                <button style={{ backgroundColor: "var(--primary)", width: "calc(100% - 20px)", whiteSpace: "nowrap", margin: 10 }}

                    onClick={() => {

                        //submit order
                        submitOrder({
                            ...order,
                            charge: order.charge + fee,
                            deliveryCharge: fee
                        }).then(() => {
                            navigate(`/auth-1/${auth.currentUser?.uid}/cart/checkout/success`)
                        }).catch(err => {
                            navigate(`/auth-1/${auth.currentUser?.uid}/cart/checkout/error`)
                        })

                    }}

                >Confirm R{fee.toFixed(2)} Delivery</button>
            </motion.div>

        </div>
    )
}

//0660 761 359